module.exports = __webpack_public_path__ + "static/media/dforest.526decec.jpg";